// extracted by mini-css-extract-plugin
export default {"clients":"HomeCompanies_clients__cenHG","clientContainer":"HomeCompanies_clientContainer__-GM4a","client":"HomeCompanies_client__A6WCO","clientImg":"HomeCompanies_clientImg__L8QTM"};